"use client";

import { useEffect } from "react";

// Module-scope guard: the component can mount more than once per page
// session (Next.js App Router + React 19 concurrent rendering can
// re-mount the effect), but the message should print exactly once.
let hasPrinted = false;

/**
 * Renders nothing visible, but logs a styled message to the browser console
 * on first page load — a small signal of craft for developers who inspect.
 *
 * @atomic-tier Atom
 * @category Brand
 */
export function ConsoleEasterEgg() {
  useEffect(() => {
    if (hasPrinted) return;
    hasPrinted = true;
    console.log(
      "%c AQ ",
      [
        "color: #f26649",
        "background: #041246",
        "font-size: 20px",
        "font-weight: 900",
        "padding: 6px 10px",
        "border-radius: 3px",
        "letter-spacing: 0.05em",
      ].join("; "),
    );
    console.log(
      "%cBuilt with obsessive attention to detail by the team at AgencyQ.\nYou noticed. That\u2019s exactly the kind of person we look for.",
      [
        "color: #f26649",
        "font-size: 12px",
        "line-height: 1.8",
        "padding: 2px 0",
      ].join("; "),
    );
    console.log(
      "%c\u2192 agencyq.com",
      [
        "color: #232eff",
        "font-size: 12px",
        "text-decoration: underline",
      ].join("; "),
    );
  }, []);

  return null;
}
